import React from 'react';
import { AlertTriangle, X } from 'lucide-react';
interface DeleteConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  documentName: string;
}
const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  documentName
}) => {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" data-id="element-1051" data-mp="27rgl2h02wzgy">
      <div className="relative w-full max-w-md mx-auto bg-white rounded-lg shadow-lg p-6" data-id="element-1052" data-mp="1k1ci8bupt3r0">
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-500 hover:text-gray-700" data-id="element-1053" data-mp="1f3u9algp6oj0">
          <X size={20} data-id="element-1054" data-mp="1p072li8bz0d8" />
        </button>
        <div className="flex items-center mb-4 text-red-600" data-id="element-1055" data-mp="1oz4f7ka7vg22">
          <AlertTriangle size={24} className="mr-2" data-id="element-1056" data-mp="34gnyf1qjo29s" />
          <h3 className="text-xl font-semibold" data-id="element-1057" data-mp="34fcw76cqz2ks">Excluir relatório</h3>
        </div>
        <div className="mb-6" data-id="element-1058" data-mp="30ekle8o88pme">
          <p className="text-gray-700 mb-4" data-id="element-1059" data-mp="30hf4nwvi84e8">
            Tem certeza que deseja excluir o relatório de{' '}
            <strong data-id="element-1060" data-mp="3e7too6101l3t">{documentName}</strong>?
          </p>
          <p className="text-gray-500 text-sm" data-id="element-1061" data-mp="3j390ytjcz8y4">
            Esta ação não pode ser desfeita. Todos os dados do relatório serão
            perdidos permanentemente.
          </p>
        </div>
        <div className="flex justify-end space-x-3" data-id="element-1062" data-mp="3s4799o0ty2mi">
          <button onClick={onClose} className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200" data-id="element-1063" data-mp="2vezl088ttfew">
            Cancelar
          </button>
          <button onClick={onConfirm} className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700" data-id="element-1064" data-mp="2ze8dzaw1l99e">
            Excluir
          </button>
        </div>
      </div>
    </div>;
};
export default DeleteConfirmationModal;